import indefiniteArticlise from 'indefinite'

export const capitalise = (name: string): string => `${name[0].toUpperCase()}${name.slice(1)}`

export const nameToIndefiniteArticle = (name: string, capitalise?: boolean): string =>
  indefiniteArticlise(name, { capitalize: capitalise })
